import React, { useEffect, useState } from 'react';
import { useAssessment } from '../../context/AssessmentContext';
import AnimatedBackground from '../ui/AnimatedBackground';
import ParticleEffect from '../ui/ParticleEffect';
import { VolumeIcon, VolumeXIcon, Flower2Icon, LeafIcon } from 'lucide-react';
const Welcome: React.FC = () => {
  const {
    setCurrentStep,
    updateAssessmentData
  } = useAssessment();
  const [audioEnabled, setAudioEnabled] = useState(false);
  useEffect(() => {
    // Record start time when component mounts
    updateAssessmentData({
      startTime: Date.now()
    });
  }, [updateAssessmentData]);
  const handleStart = () => {
    setCurrentStep(1);
  };
  const toggleAudio = () => {
    setAudioEnabled(!audioEnabled);
    // In a real implementation, this would play/pause background audio
  };
  return <div className="min-h-screen flex flex-col items-center justify-center px-4 relative overflow-hidden" data-id="element-773">
      <AnimatedBackground type="transition" data-id="element-774" />
      <ParticleEffect count={70} data-id="element-775" />
      {/* Garden elements */}
      <div className="absolute top-10 left-10 garden-leaf" data-id="element-776">
        <LeafIcon size={80} className="text-green-200" data-id="element-777" />
      </div>
      <div className="absolute bottom-20 right-20 garden-leaf" data-id="element-778">
        <LeafIcon size={100} className="text-green-200" data-id="element-779" />
      </div>
      <div className="absolute top-1/4 right-1/4 garden-flower" data-id="element-780">
        <Flower2Icon size={60} className="text-pink-200" data-id="element-781" />
      </div>
      <div className="absolute bottom-1/3 left-1/3 garden-flower" data-id="element-782">
        <Flower2Icon size={70} className="text-pink-200" data-id="element-783" />
      </div>
      {/* Sacred geometry patterns */}
      <div className="flower-of-life absolute inset-0 opacity-20 z-[-1]" data-id="element-784"></div>
      <div className="metatron-cube absolute inset-0 opacity-15 z-[-1] slow-rotate" data-id="element-785"></div>
      {/* Audio toggle button */}
      <button onClick={toggleAudio} className="absolute top-6 right-6 bg-white bg-opacity-10 p-3 rounded-full backdrop-blur-sm z-10" data-id="element-786">
        {audioEnabled ? <VolumeIcon className="text-white" size={20} data-id="element-787" /> : <VolumeXIcon className="text-white" size={20} data-id="element-788" />}
      </button>
      {/* Luminara image */}
      <div className="absolute top-1/2 transform -translate-y-1/2 -right-20 opacity-30 z-0 hidden md:block" data-id="element-789">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qZVheqmct1MU2ySN36VNGU/openart-6db1d22a821d449cab14977aa32af312_raw.png" alt="Luminara ethereal guardian" className="w-72 h-auto" data-id="element-790" />
      </div>
      {/* Logo */}
      <div className="mb-8 transform hover:scale-105 transition-transform" data-id="element-791">
        <h1 className="text-5xl md:text-7xl font-bold text-white tracking-wide" data-id="element-792">
          <span className="text-pink-300" data-id="element-793">Seven</span>After
        </h1>
        <div className="h-1 w-24 bg-gradient-to-r from-orange-400 to-pink-300 mx-auto mt-2" data-id="element-794"></div>
      </div>
      {/* Main content */}
      <div className="max-w-2xl w-full bg-white bg-opacity-10 backdrop-blur-md rounded-2xl p-8 border border-white border-opacity-20 shadow-xl relative overflow-hidden" data-id="element-795">
        <div className="spiral-pattern absolute inset-0 opacity-20 z-0" data-id="element-796"></div>
        <div className="lotus-pattern absolute inset-0 opacity-20 z-0" data-id="element-797"></div>
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4 fade-in relative z-10" data-id="element-798">
          Welcome, beautiful soul, to SevenAfter
        </h2>
        <p className="text-xl text-center text-pink-200 mb-6 mystical-text slide-up relative z-10" style={{
        animationDelay: '0.2s'
      }} data-id="element-799">
          Where gentle hearts find their healing home
        </p>
        <p className="text-center text-white text-opacity-90 mb-8 slide-up relative z-10" style={{
        animationDelay: '0.4s'
      }} data-id="element-800">
          This sacred assessment reveals your personalized path through our
          <br data-id="element-801" />
          Seven Sacred Gardens of evidence-based mystical healing.
        </p>
        <button onClick={handleStart} className="mystical-button w-full max-w-md mx-auto block py-4 text-lg glow slide-up relative z-10" style={{
        background: 'linear-gradient(135deg, #F8BBD0 0%, #FF7B54 100%)',
        animationDelay: '0.6s'
      }} data-id="element-802">
          Enter Your Sacred Journey
        </button>
      </div>
      {/* Progress indicator */}
      <div className="mt-12 flex items-center justify-center space-x-2" data-id="element-803">
        {Array.from({
        length: 7
      }).map((_, index) => <div key={index} className={`h-2 w-2 rounded-full ${index === 0 ? 'bg-orange-400' : 'bg-white bg-opacity-30'}`} data-id="element-804" />)}
      </div>
      <div className="sacred-pattern absolute inset-0 opacity-10 z-[-1]" data-id="element-805"></div>
      <div className="garden-elements absolute inset-0 opacity-15 z-[-1]" data-id="element-806"></div>
    </div>;
};
export default Welcome;